import useIsFeatureEnabled from 'components/hooks/use_is_feature_enabled';
import useIsTeamFlagEnabled from 'components/hooks/use_is_team_flag_enabled';

// Team Assist requires both the team flag and the conversation:general permission.
// Conversation-view-only agents lack the permission and would be logged out if they
// subscribed to the team-assists topic, so they must not see the panel either.
export default function useIsTeamAssistEnabled() {
  const isTeamFlagEnabled = useIsTeamFlagEnabled();
  const isFeatureEnabled = useIsFeatureEnabled();

  return isTeamFlagEnabled('teamAssistAI') && isFeatureEnabled('conversation:general');
}
